module.exports = __webpack_public_path__ + "static/media/blank-opinions.221f5ac2.png";